import '@moneysmart/cargo-vue/dist/cargo-vue.css'
import './src/plugins/icons'
import './email-capture'
import './ms-auth'
